var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "wp-footer container-fluid" }, [
      _c("p", [_vm._v("© Copyright 2020 Best Seat In The House (Jamaica)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }